export interface IPlantillaCrearCheckList {
  nombrePlantilla?: string;
  modeloEquipo: string;
  grupoVerificacion: string;
}

export const InitialPlantillaCrearCheckList: IPlantillaCrearCheckList = {
  nombrePlantilla: "",
  modeloEquipo: "",
  grupoVerificacion: "",
};
